import { render, staticRenderFns } from "./tableCellCo123Menu.vue?vue&type=template&id=646fbe88&scoped=true"
import script from "./tableCellCo123Menu.vue?vue&type=script&lang=js"
export * from "./tableCellCo123Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646fbe88",
  null
  
)

export default component.exports